import { render, staticRenderFns } from "./mallDistribution_2.vue?vue&type=template&id=5ca787d1"
import script from "./mallDistribution_2.vue?vue&type=script&lang=js"
export * from "./mallDistribution_2.vue?vue&type=script&lang=js"
import style0 from "./mallDistribution_2.vue?vue&type=style&index=0&id=5ca787d1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports